var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',_vm._g(_vm._b({staticClass:"pager-wrapper",attrs:{"show-sizer":""}},'Page',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }